import { render, staticRenderFns } from "./MFA.vue?vue&type=template&id=07ee4c89&"
import script from "./MFA.vue?vue&type=script&lang=js&"
export * from "./MFA.vue?vue&type=script&lang=js&"
import style0 from "./MFA.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MFA.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports